import { cast, types } from 'mobx-state-tree';
import { createThunk, model, Model } from 'mst-collection';

import {
  Api,
  IContactUsMessageBodyRequest,
  IContactUsTicketBodyRequest,
} from '@api';
import { trimData } from '@utils';
import { EnquiryType, EnquiryTypeModel } from './EnquiryTypeModel';

type ContactUsMessageBodyRequestType = IContactUsMessageBodyRequest;
type ContactUsTicketBodyRequestType = IContactUsTicketBodyRequest;

export class ContactUs extends Model({
  enquiryTypes: types.array(EnquiryTypeModel),
}) {
  get preparedEnquiryTypes() {
    return this.enquiryTypes.map(({ name, id }) => ({
      title: name,
      value: id,
    }));
  }

  setEnquiryTypes(values: EnquiryType[]) {
    this.enquiryTypes = cast(values);
  }

  fetchEnquiryTypes = createThunk(() => {
    return async function fetchTypes(this: ContactUs) {
      const res = await Api.ContactUs.getEnquiryTypes();

      this.setEnquiryTypes(res.data);
    };
  });

  sendMessage = createThunk(
    (params: ContactUsMessageBodyRequestType) => {
      return async function sendMessage() {
        const data = trimData(params);

        await Api.ContactUs.sendMessage(data);
      };
    },
  );

  sendTicket = createThunk(
    (params: ContactUsTicketBodyRequestType) => {
      return async function sendTicket() {
        const data = trimData(params);

        await Api.ContactUs.sendTicket(data);
      };
    },
  );
}

export const ContactUsModel = model(ContactUs);
